// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"fff9d840","296":"0f108b2c","428":"b5665331","433":"697a6a6b","631":"b38edd7d","731":"e351e8d4","785":"3b96e650"}[chunkId] + ".chunk.js";
};